module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-chunk-intro-card01.48a15766.jpg";